export default "__VITE_ASSET__sFGKRHfC__"